import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgIf } from '@angular/common';
import { IconComponent } from './icon.component';

/** Pill-shaped selectable chip (segmented control / filters). */
@Component({
  selector: 'app-chip',
  standalone: true,
  imports: [NgIf, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<button (click)="act.emit()" [style.background]="active ? 'var(--brand-ink)' : 'var(--fr-surface)'"
      [style.color]="active ? '#fff' : 'var(--fr-text-2)'"
      [style.box-shadow]="active ? 'none' : 'inset 0 0 0 1.5px var(--fr-border-2)'"
      style="height:38px;padding:0 15px;border-radius:999px;border:none;cursor:pointer;font-size:14px;
             font-weight:650;white-space:nowrap;flex-shrink:0;display:inline-flex;align-items:center;gap:6px;
             font-family:var(--fr-font);transition:all .15s ease;letter-spacing:-0.01em">
      <app-icon *ngIf="icon" [name]="icon" [size]="16"></app-icon>
      <ng-content></ng-content>
    </button>`,
})
export class ChipComponent {
  @Input() active = false;
  @Input() icon?: string;
  @Output() act = new EventEmitter<void>();
}
